import renderInputField from 'components/FormControls/textInput'
import { Button, Grid } from 'gu-ui-kit'
import PropTypes from 'prop-types'
import React, { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { Field, Form, reduxForm } from 'redux-form'
import validator from 'utils/asyncValidator'
import shouldAsyncValidate from 'utils/shouldAsyncValidate'
import { Link } from 'react-router-dom'
import { ROUTES } from 'constants/routes'
import useGeneratePathI18n from 'utils/hooks/useGeneratePathI18n'
import { RECOVER_SUBMIT } from 'modules/Auth/types'
import { useParams } from 'react-router'
import { validationSchema } from 'modules/Forms/Auth/Recover/validationSchema'
import { useBreakpoint } from 'utils/hoc/breakpointProvider'

let RecoverForm = ({ handleSubmit, submitting, form, onClose, invalid, autofill }) => {
  const { t } = useTranslation()
  const pathGen = useGeneratePathI18n()
  const breakpoint = useBreakpoint()

  const { email } = useParams()

  useEffect(() => {
    if (email) {
      autofill('email', email)
    }
  }, [email])

  const submit = async (values, dispatch) => {
    return new Promise((resolve, reject) => {
      dispatch({
        meta: { resolve, reject },
        type: RECOVER_SUBMIT,
        payload: {
          data: values,
          formName: form,
        },
      })
    }).then(() => onClose(values.email))
  }

  return (
    <Form
      onSubmit={handleSubmit(submit)}
      noValidate
    >
      <div className={'margin-bottom-40'}>
        <Field
          fullWidth
          name="email"
          type="email"
          component={renderInputField}
          t={t}
          label={t('auth::forms.recover.fields.email.label')}
        />
      </div>

      <Grid
        direction={!breakpoint.fb ? 'column-reverse' : 'row'}
        alignItems={'center'}
        justifyContent={'start'}
        wrap={false}
        gap={16}
      >
        <Button
          fullWidth
          disabled={submitting}
          component={Link}
          to={pathGen(ROUTES.AUTH_LOGIN)}
          variant={'secondary'}
          grey
          size={'l'}
        >
          {t('common::buttons.login')}
        </Button>
        <Button
          fullWidth
          disabled={invalid || submitting}
          size={'l'}
          variant={'primary'}
          type={'submit'}
        >
          {t('auth::forms.recover.buttons.submit')}
        </Button>
      </Grid>
    </Form>
  )
}

RecoverForm = reduxForm({
  form: 'RecoverForm',
  updateUnregisteredFields: true,
  enableReinitialize: true,
  initialValues: {
    email: '',
  },
  shouldAsyncValidate: shouldAsyncValidate,
  asyncValidate: validator(validationSchema),
})(RecoverForm)

RecoverForm.propTypes = {
  invalid: PropTypes.bool,
  onClose: PropTypes.func,
  handleSubmit: PropTypes.func,
  submitting: PropTypes.bool,
  form: PropTypes.string,
  autofill: PropTypes.func,
}

RecoverForm.defaultValues = {
  onClose: () => {},
  handleSubmit: () => {},
  submitting: false,
  form: 'RecoverForm',
}

export default RecoverForm
